// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3dJql","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1f2r3"};